/* =========================================================
   Affiche ÉQUITATION « Les concours » — palmarès, saison, bilan, complet, podium.
   API : SNEqConcours.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, date, cavalier, cheval,
              mode 'palmares' → p1..p8 (« 12 juin|Rambouillet|1,20 m|1er »)
              mode 'saison'   → c1..c20 (0 = sans-faute, 4, 8, E = éliminé)
              mode 'bilan'    → l1..l8 (« Libellé|valeur »)
              mode 'complet'  → dressage, cross, obstacles, total, classement
              mode 'podium'   → rang, partants
              + s1..s3 (« valeur|libellé ») pour le bandeau }
     opts : { palette }

   Auto-suffisant (aucun fetch, aucune image) → re-render serveur direct.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie:    { label:'Craie',    bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', sable:'#E4D5B7', deep:'#D8C7A4' },
    sable:    { label:'Sable',    bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', sable:'#DCCFB6', deep:'#CDBE9E' },
    carriere: { label:'Carrière', bg:'#12362B', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#164536', sable:'#C9B489', deep:'#0B271F' },
    nuit:     { label:'Nuit',     bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', sable:'#C9B489', deep:'#082444' },
  };
  const ROUGE = '#C4372B';

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  function stats(p, data, y) {
    const it = [];
    for (let i = 1; i <= 3; i++) {
      const raw = String(data['s' + i] || '').trim(); if (!raw) continue;
      const [v, l] = raw.split('|').map(s => (s || '').trim());
      if (v) it.push([v, l || '']);
    }
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 38, 0.56, 0, 17), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  /* « 1er », « 2e », « 3e » sont les seules places qui montent sur un podium. */
  const PODIUM = new Set(['1', '1er', '1ER', '2', '2e', '2E', '3', '3e', '3E']);
  const estPodium = v => PODIUM.has(String(v || '').trim());

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const mode = String(data.mode || 'palmares').toLowerCase();
    const cx = PW / 2;

    const DEF = { palmares: 'NOTRE PALMARÈS', saison: 'NOTRE SAISON', bilan: 'NOTRE BILAN', complet: 'LES TROIS PHASES', podium: 'NOTRE PODIUM' };
    const titre = up(data.titre) || DEF[mode] || 'NOS CONCOURS';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || 'SAISON DE CONCOURS';
    const sous = [up(data.club), up(data.date)].filter(Boolean).join(' · ');

    let corps = '', barreY = 0, pied = 1000;

    if (mode === 'palmares') {
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['p' + i] || '').trim(); if (!raw) continue;
        const c = raw.split('|').map(s => (s || '').trim());
        if (c[1]) l.push(c);
      }
      if (l.length) {
        const zone = 620, pas = Math.min(102, zone / l.length), y0 = 340 + (zone - pas*l.length) / 2;
        l.forEach((r, i) => {
          const y = y0 + i * pas, po = estPodium(r[3]);
          corps += (r[0] ? T(MX, y - 12, 13, p.muted, esc(up(r[0])), { w:600, ls:2, a:'start' }) : '')
            + T(MX, y + 16, fit(r[1], 380, 26, 0.60, 0, 15), p.ink, esc(r[1]), { f:'Oswald', w:700, a:'start' })
            + (r[2] ? T(PW - MX - 96, y + 12, 18, p.muted, esc(r[2]), { w:600, a:'end' }) : '')
            + (r[3] ? T(PW - MX, y + 16, 34, po ? p.accent : p.muted, esc(r[3]), { f:'Oswald', w:700, a:'end' }) : '');
          if (i < l.length - 1) corps += `<line x1="${MX}" y1="${(y + pas/2 - 7).toFixed(1)}" x2="${PW-MX}" y2="${(y + pas/2 - 7).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
        });
      } else corps = T(cx, 600, 20, p.muted, 'FORMAT : DATE, LIEU, ÉPREUVE, CLASSEMENT', { w:600, ls:2 });

    } else if (mode === 'saison') {
      const res = [];
      for (let i = 1; i <= 20; i++) {
        const raw = String(data['c' + i] || '').trim(); if (!raw) continue;
        res.push(/^e/i.test(raw) ? -1 : (num(raw) || 0));
      }
      if (res.length) {
        const COL = { 0: p.accent, 4: p.ink };
        const cols = res.length > 12 ? 5 : 4, r = 38;
        const gx = (PW - 2*104) / (cols - 1);
        res.forEach((v, i) => {
          const c = i % cols, lg = Math.floor(i / cols);
          const ccx = 104 + c * gx, ccy = 386 + lg * 118;
          if (v === -1) corps += `<circle cx="${ccx.toFixed(1)}" cy="${ccy}" r="${r}" fill="none" stroke="${ROUGE}" stroke-width="3"/>`
            + `<line x1="${(ccx-17).toFixed(1)}" y1="${ccy-17}" x2="${(ccx+17).toFixed(1)}" y2="${ccy+17}" stroke="${ROUGE}" stroke-width="3"/>`;
          else {
            corps += `<circle cx="${ccx.toFixed(1)}" cy="${ccy}" r="${r}" fill="${COL[v] || p.muted}" opacity="${v === 0 ? 1 : v === 4 ? 0.85 : 0.35}"/>`;
            if (v > 0) corps += T(ccx, ccy + 10, 26, p.bg, String(v), { f:'Oswald', w:700 });
          }
        });
        /* légende : sans elle, les couleurs ne veulent rien dire */
        const leg = [['Sans-faute', p.accent, 1], ['4 points', p.ink, 0.85], ['8 et plus', p.muted, 0.35]];
        const ly = 386 + Math.ceil(res.length / cols) * 118 + 4;
        leg.forEach((L, i) => {
          const x = 130 + i * 200;
          corps += `<circle cx="${x}" cy="${ly}" r="9" fill="${L[1]}" opacity="${L[2]}"/>`
            + T(x + 20, ly + 5, 13, p.muted, esc(up(L[0])), { w:600, ls:1.5, a:'start' });
        });
      } else corps = T(cx, 600, 20, p.muted, 'UN CONCOURS PAR CASE : 0, 4, 8 OU E', { w:600, ls:2 });
      barreY = 1000; pied = 0;

    } else if (mode === 'complet') {
      const ph = [['Dressage', data.dressage], ['Cross', data.cross], ['Saut d’obstacles', data.obstacles]];
      ph.forEach((f, i) => {
        const y = 350 + i * 172;
        corps += `<rect x="${MX}" y="${y - 54}" width="${PW - 2*MX}" height="128" rx="16" fill="${p.card}"/>`
          + T(MX + 34, y - 20, 14, p.accent, String(i + 1), { w:700, ls:3, a:'start' })
          + T(MX + 34, y + 16, 30, p.ink, f[0], { f:'Oswald', w:700, a:'start' })
          + T(PW - MX - 34, y + 24, 56, p.ink, esc(String(f[1] || '—')), { f:'Oswald', w:700, a:'end' });
      });
      corps += `<rect x="${MX}" y="880" width="${PW-2*MX}" height="112" rx="16" fill="${p.ink}"/>`
        + T(cx, 916, 13, p.accent, 'TOTAL', { w:700, ls:8 })
        + `<text x="${cx}" y="966" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.bg}"><tspan font-size="46">${esc(String(data.total || '—'))}</tspan>${data.classement ? `<tspan font-size="20" fill="${p.muted}" dx="10">PTS · ${esc(up(data.classement))}</tspan>` : ''}</text>`;
      pied = 1030;

    } else if (mode === 'podium') {
      const rang = String(data.rang || '1').replace(/[^\d]/g, '') || '1';
      const marches = [[2, 190], [1, 260], [3, 150]];
      marches.forEach(([r, h], i) => {
        const w = 168, x = cx - 252 + i * 168, sol = 830;
        const mien = String(r) === rang;
        corps += `<rect x="${x}" y="${(sol - h).toFixed(1)}" width="${w}" height="${h}" rx="6" fill="${mien ? p.accent : p.card}"/>`
          + T(x + w/2, sol - h + 46, 40, mien ? p.bg : p.muted, r + (r === 1 ? 'er' : 'e'), { f:'Oswald', w:700 });
      });
      corps += `<line x1="${MX}" y1="830" x2="${PW-MX}" y2="830" stroke="${p.line}" stroke-width="2.5"/>`
        + `<text x="${cx}" y="400" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.accent}"><tspan font-size="132">${esc(rang)}</tspan><tspan font-size="46" dy="-34">${rang === '1' ? 'er' : 'e'}</tspan></text>`
        + (data.partants ? T(cx, 444, 15, p.muted, 'SUR ' + esc(up(data.partants)) + ' PARTANTS', { w:600, ls:5 }) : '');
      barreY = 950; pied = 1024;

    } else { /* bilan */
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['l' + i] || '').trim(); if (!raw) continue;
        const [lab, v] = raw.split('|').map(s => (s || '').trim());
        if (lab && v) l.push([lab, v]);
      }
      if (l.length) {
        const zone = 600, pas = Math.min(96, zone / l.length), y0 = 348 + (zone - pas*l.length) / 2 - 40;
        l.forEach((r, i) => {
          const y = y0 + i * pas, dernier = i === l.length - 1;
          corps += T(MX, y, 17, p.muted, esc(up(r[0])), { w:600, ls:2, a:'start' })
            + T(PW - MX, y + 8, fit(r[1], 420, 44, 0.58, 0, 20), dernier ? p.accent : p.ink, esc(r[1]), { f:'Oswald', w:700, a:'end' });
          if (!dernier) corps += `<line x1="${MX}" y1="${(y + pas/2 - 14).toFixed(1)}" x2="${PW-MX}" y2="${(y + pas/2 - 14).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
        });
      } else corps = T(cx, 600, 20, p.muted, 'FORMAT : LIBELLÉ, BARRE VERTICALE, VALEUR', { w:600, ls:2 });
      pied = 976;
    }

    const couple = [esc(up(data.cavalier)), esc(up(data.cheval))].filter(Boolean).join(' &amp; ');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${barreY ? stats(p, data, barreY) : ''}
${pied && couple ? T(cx, pied, fit(couple, 690, 19, 0.60, 1, 12), p.ink, couple, { f:'Oswald', w:700, ls:1 }) : ''}
</svg>`;
  }

  window.SNEqConcours = { render, PALETTES };
})();
